const DEVICE_ID_KEY = 'auth_device_id';

let cachedDeviceId: string | null = null;

function randomUuid(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export async function getDeviceId(): Promise<string> {
  if (cachedDeviceId) return cachedDeviceId;

  let stored: string | null = null;
  try {
    stored = localStorage.getItem(DEVICE_ID_KEY);
  } catch {
    stored = null;
  }
  if (stored) {
    cachedDeviceId = stored;
    return stored;
  }

  const id = randomUuid();
  try {
    localStorage.setItem(DEVICE_ID_KEY, id);
  } catch {
    /* ignore */
  }
  cachedDeviceId = id;
  return id;
}
